import "../Styles/main.scss";
import "./index.scss";
import "../../components/cmsShared";
import { Slick } from "@/pages/vendors/vendor.slick";

/******** 产品详情页图片滚动 ********/
function setupProductDetailSlides() {
    const $productSlides = $(".m-product-detail__slider");
    const $status = $(".m-product-detail__pages");
    // eslint-disable-next-line fht-eslint-rules/jquery-argument-validator
    $productSlides.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        const i = (currentSlide ? currentSlide : 0) + 1;
        $status.text(i + "/" + slick.slideCount);
    });
    if ($productSlides.find(".m-product-detail__slider-item").length) {
        new Slick($(".m-product-detail__slider"), {
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe: true,
            arrows: false,
            autoplay: false,
            infinite: false,
        });
    }
}

/******** 帖子详情页图片滚动 ********/

function setupTopicPostDetailSlides() {
    const $topicPostSlides = $(".m-topicpost-detail__slider");
    const $status = $(".m-topicpost-detail__pages");
    // eslint-disable-next-line fht-eslint-rules/jquery-argument-validator
    $topicPostSlides.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        const i = (currentSlide ? currentSlide : 0) + 1;
        $status.text(i + "/" + slick.slideCount);
    });
    if ($topicPostSlides.find(".m-topicpost-detail__slider-item").length) {
        new Slick($(".m-topicpost-detail__slider"), {
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe: true,
            arrows: false,
            autoplay: false,
            infinite: false,
        });
    }
}

/******** 首页Banner图片滚动 ********/
export function initBannerSlides(): void {
    const $bannerSlides = $(".banner-slides");
    if ($bannerSlides.find(".banner-slides__item").length) {
        new Slick($bannerSlides, {
            dots: true,
            autoplay: true,
            autoplaySpeed: 5000,
        });
    }
}

$(function () {
    setupProductDetailSlides();
    setupTopicPostDetailSlides();
    initBannerSlides();
});
